import React from 'react';
import {currencyFormat, EMPTY_VALUES, getDateFormat} from '../../../../../Apis/functions';
import DividerWithText from '../../../../../components/DividerWithText';
import NotInformation from '../../../../../components/NotInformation';
import { DishCategoryEnum, MealTypeEnum } from '../Model/Model';
import RowResumeText from './../../../../../components/RowResumeText';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Summary = ({
    t,
    item,
    selectedMealTime,
    selectedDepartment,
    selectedUsers,
    allItem = [],
    allCafeterias = [],
    showCostInfo
}) => {


    return (
        <div className='row'>
            <DividerWithText title={t('details')} />
            <div className='w-100 d-flex justify-content-center mt-3 mb-3'>
                <div className='d-flex flex-column align-items-start justify-content-center w-600px'>
                    <div className='row w-100'>
                        <div className='col-md-6 px-0'>
                            <RowResumeText
                                title={t('meal')}
                                value={(allItem && allItem.find((ct) => ct.id === item.dish)?.name) || EMPTY_VALUES.DEFAULT}
                            />
                        </div>
                        <div className='col-md-6 px-0'>
                            <RowResumeText title={t('meal_type')} value={t(MealTypeEnum[item.mealType]?.name) || EMPTY_VALUES.DEFAULT} />
                        </div>
                    </div>
                    <div className='row w-100 mt-2'>

                        <div className='col-md-6 px-0'>
                            <RowResumeText
                                title={t('course_type')}
                                value={t(DishCategoryEnum[item.courseType]?.name) || EMPTY_VALUES.DEFAULT}
                            />
                        </div>
                    </div>
                    <div className='mt-0'>
                         <div className='mt-3'>
                            <RowResumeText
                                title={t('service_time')}
                                value={
                                    Array.isArray(selectedMealTime) && selectedMealTime.length > 0
                                        ? selectedMealTime.map((i, index) => (
                                            <React.Fragment key={index}>
                                                {t(i.label)} {' '}
                                                <span className='ibl-font-w-600 fs-14px'>
                                                   {i.unit}{' '}{t('units').toLowerCase()}
                                                </span>
                                            </React.Fragment>
                                        ))
                                        : EMPTY_VALUES.DEFAULT
                                }
                            />
                        </div>
                    </div>
                    <div className='mt-3'>
                        <RowResumeText
                            title={t('diner')}
                            value={(allCafeterias && allCafeterias.find((ct) => ct.id === item.diner)?.name) || EMPTY_VALUES.DEFAULT}
                        />
                    </div>
                    {showCostInfo &&
                        <div className='mt-3'>
                            <RowResumeText
                                title={t('meal_cost')}
                                value={`${'$ ' + currencyFormat(parseFloat(item?.cost))}`}
                            />
                        </div>
                    }
                    <div className='row w-100'>
                        <div className='col-md-6 px-0 mt-3'>
                            <RowResumeText title={t('release_date')} value={getDateFormat(item?.releaseDate, false)} />
                        </div>

                        <div className='col-md-6 px-0 mt-3'>
                            <RowResumeText title={t('release_hour')} value={item?.releaseHour} />
                        </div>
                    </div>
                    <div className='mt-3'>
                        <RowResumeText
                            title={t('cafeteria_serving_date')}
                            value={getDateFormat(item?.cafeteriaServingDate, false)}
                        />
                        <div className='mt-3'>
                            <RowResumeText
                                title={t('authorized_departments')}
                                value={
                                    Array.isArray(selectedDepartment) && selectedDepartment.length > 0
                                        ? selectedDepartment.map((i) => t(i.label))
                                        : '-'
                                }
                            />
                        </div>
                        <div className='mt-3'>
                            <RowResumeText
                                title={t('department_priority')}
                                value={
                                    Array.isArray(selectedDepartment) && selectedDepartment.length > 0
                                        ? selectedDepartment.map((i, index) => (
                                            <React.Fragment key={index}>
                                                {t(i.label)} {t('after')}{' '}
                                                <span className='ibl-font-w-600 fs-14px'>
                                                    {i.unit}
                                                </span>
                                            </React.Fragment>
                                        ))
                                        : EMPTY_VALUES.DEFAULT
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <DividerWithText title={t('custom_access')} />
            <div className={"my-3"}>
                {Array.isArray(selectedUsers) && selectedUsers.length > 0 ? (
                    <div className='w-100 d-flex justify-content-center'>
                        <div className='row w-600px'>
                            {selectedUsers.map((username, index) => (
                                <div className='col-md-6 mb-3' key={index}>
                                    <RowResumeText title={t('name')} value={username.label} />
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <NotInformation card={true} text={t('no_information')} />
                )}
            </div>
        </div>
    );
};

export default Summary;
